import axios from './configAxios';

export const postToTransporterRegistration = async (requestData) => {
  return await axios.post('transporter/registration/', requestData);
};
